import { DailyCheckInClaim, DailyCheckInClaimInput } from '@apeiron/reward'
import { deserializeListData, MayNull } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import { dailyCheckInClaimSchema } from '@src/deserialize/yup/reward'
import graphql from '@src/graphql/mutation/claimDailyCheckIn'
import { useCallback, useState } from 'react'

const useClaimDailyCheckIn = (): Hook => {
  const [claimDailyCheckIn, { loading }] = useMutation(graphql)

  const [data, setData] = useState<MayNull<Response>>(null)

  const mutate = useCallback(
    async (input: DailyCheckInClaimInput[]): Promise<Response> => {
      const response = await claimDailyCheckIn({
        variables: {
          input: {
            claimData: input
          }
        }
      })

      const deserialized = deserializeListData<DailyCheckInClaim>(
        response,
        dailyCheckInClaimSchema
      )

      setData(deserialized[0])

      return deserialized[0]
    },
    [claimDailyCheckIn]
  )

  return {
    data,
    loading,
    mutate
  }
}

type Response = MayNull<DailyCheckInClaim>

type Hook = {
  data: MayNull<DailyCheckInClaim>
  loading: boolean
  mutate: (input: DailyCheckInClaimInput[]) => Promise<Response>
}

export default useClaimDailyCheckIn
